import {EditorItemKey} from "../editorSlice";
import {MenuDocument} from "../MenuDocumentModel";
import {clone, insert} from "ramda";
import {Active, Over} from "@dnd-kit/core";

export type DndId = string
export type DndState = DndId[][]

export function documentToDndState(document: MenuDocument): DndState {
    return document.pages.map((page, pageIndex) =>
        page.map((item, itemIndex) =>
            itemKeyToDndId({
                page: pageIndex,
                item: itemIndex
            })));
}

export function dndMove(dndState: DndState, active: Active, over: Over): DndState | null {
    const {page: fromPage, item: fromIndex} = dndIdToItemKey(active.id);
    const {page: toPage, item: overIndex} = dndIdToItemKey(over.id);

    // do nothing since dnd-kit handles this itself
    if (fromPage === toPage) {
        return null;
    }

    const isBelowOverItem =
        over &&
        active.rect.current.translated &&
        active.rect.current.translated.top >
        over.rect.top + over.rect.height;

    const newIndex = overIndex + (isBelowOverItem ? 1 : 0);

    // do nothing when moving the last item of one page to the first item of the next since that is not a valid operation
    if (fromIndex === dndState[fromPage].length - 1 && toPage === fromPage + 1 && newIndex === 0) {
        return null;
    }

    const result = clone(dndState);
    result[fromPage] = result[fromPage].filter(x => x !== active.id);
    result[toPage] = result[toPage].filter(x => x !== active.id);
    result[toPage] = insert(newIndex, active.id, result[toPage]);
    return result;
}

export function itemKeyToDndId(key: EditorItemKey): string {
    return `${key.page}/${key.item}`;
}

export function dndIdToItemKey(dndId: string): EditorItemKey {
    const [page, item] = dndId.split("/").map(i => parseInt(i));
    return {
        page: page,
        item: item
    };
}